const EVENTS_BASE_URL = '/events/message';

export function getMessageEvents(params) {
  return {
    method: 'GET',
    url: `/v1${EVENTS_BASE_URL}`,
    params
  };
}
